import React, { FC, useState } from 'react';
import { MainTemplate } from '../../components/layouts';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { OrganizationFrFragment, PersonFrFragment, usePersonsQuery } from '../../api';
import { Grid, Tooltip } from '@material-ui/core';
import TABLE_OPTIONS from '../../config/tables';
import MUIDataTable, { MUIDataTableColumnDef } from 'mui-datatables';
import { usePermission } from '../../hooks/usePermission';
import { Link, useHistory } from 'react-router-dom';
import { BtnNew } from '../../components/BtnNew';
import moment from 'moment';

const PER_PAGE = 10;

const Page: FC<{}> = () => {
  const [page, setPage] = useState<number>(0);
  const [filter, setFilter] = useState<any>({
    archive: null,
  });
  const { push } = useHistory();
  const access = usePermission('directory', 'persons');
  const { data } = usePersonsQuery({ variables: { skip: page * PER_PAGE, first: PER_PAGE, filter } });

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'id',
      label: '',
      options: {
        sort: false,
        display: false,
      },
    },
    {
      name: 'registryNumber',
      label: 'Реестровый номер',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: Pick<PersonFrFragment, 'id'>, meta) => {
          return (
            <Tooltip title="Перейти в карточку" placement="top-start">
              <Link
                style={{
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                }}
                to={`/person/${meta.rowData[0]}`}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
    },
    {
      name: 'lastname',
      label: 'Фамилия',
      options: {
        sort: false,
      },
    },
    {
      name: 'firstname',
      label: 'Имя',
      options: {
        sort: false,
      },
    },
    {
      name: 'patronymic',
      label: 'Отчество',
      options: {
        sort: false,
      },
    },
    {
      name: 'birthday',
      label: 'Дата рождения',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          return moment(value).format('DD.MM.YYYY');
        },
      },
    },
    {
      name: 'isMale',
      label: 'Пол',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: Pick<PersonFrFragment, 'isMale'>) => {
          return value ? 'Муж' : 'Жен';
        },
      },
    },
  ];

  return (
    <MainTemplate pageName="Персоны" url="">
      <DictionaryWrapper>
        <MUIDataTable
          title={
            <React.Fragment>
              <h2>Справочник персон</h2>
              <Grid container spacing={1}>
                {access.includes(2) && <Grid item>{<BtnNew onClick={() => push('/person/new')} />}</Grid>}
              </Grid>
            </React.Fragment>
          }
          data={(data && data.dirPersons) || []}
          columns={columns}
          options={{
            ...TABLE_OPTIONS,
            onTableChange: (action, tableState) => {
              switch (action) {
                case 'changePage':
                  setPage(tableState.page);
                  break;
              }
            },
            rowsPerPage: PER_PAGE,
            count: data && data.count,
            page,
          }}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
